import { simulatorBackend, evaluationsBackend } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

const riskEvaluationsRoute = 'risk-evaluation';

export const getRiskEvaluationByIdNumber = async riskEvaluationId => {
  const { data } = await simulatorBackend.get(`${riskEvaluationsRoute}/idNumber/${riskEvaluationId}`, getOptions());
  return data;
};

export const getRiskEvaluationById = async riskEvaluationId => {
  const { data } = await simulatorBackend.get(`${riskEvaluationsRoute}/${riskEvaluationId}`, getOptions());
  return data;
};

export const createRiskEvaluation = async idNumber => {
  const newRiskEvaluation = {
    idNumber
  };
  const { data } = await simulatorBackend.post(`${riskEvaluationsRoute}`, newRiskEvaluation, getOptions());
  return data;
};

export const calculateRiskEvaluation = async riskEvaluation => {
  const { data } = await simulatorBackend.post(`${riskEvaluationsRoute}/calculate`, riskEvaluation, getOptions());
  return data;
};

export const patchRiskEvaluation = async riskEvaluation => {
  const { data } = await simulatorBackend.patch(`${riskEvaluationsRoute}/${riskEvaluation._id}`, riskEvaluation, getOptions());
  return data;
};

export const getRiskEvaluationDocument = async (idNumber, riskEvaluation) => {
  const { data } = await simulatorBackend.post(`${riskEvaluationsRoute}/document/${idNumber}`, riskEvaluation, getOptions());
  return data;
};

export const getEligibilityData = async idNumber => {
  try {
    const resp = await evaluationsBackend.get(`/approver/prospect-information-equifax/${idNumber}`, getOptions());
    const { data } = resp;
    return data;
  } catch (e) {
    throw new Error(e);
  }
};
